import type { FC } from '../../lib/teact/teact'
import React, { useCallback } from '../../lib/teact/teact'

import useLang from '../../hooks/useLang'

import Button from './Button'

import './SomethingWentWrong.scss'

const SomethingWentWrong: FC = () => {
  const lang = useLang()

  const handleReload = useCallback(() => {
    window.location.reload()
  }, [])

  return (
    <div id="SomethingWentWrong">
      <div className="content">
        <h3 className="title">{lang('WebErrorTitle')}</h3>
        <div className="description">{lang('Error.AnError')}</div>
        <div className="actions">
          <Button isText ripple onClick={handleReload}>
            {lang('WebApp.ReloadPage')}
          </Button>
        </div>
      </div>
    </div>
  )
}

export default SomethingWentWrong
